import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('[SaResouces] Dummy');

// #region load Rpo
// LOAD
export const loadResouceRtoOver = createAction('[SaRES] Load Override Rto');
export const loadResouceRtoOverSuccess = createAction(
  '[SaRES] Load Override Rto Success',
  props<{ resRto: any[] }>()
);
//#endregion
